<template>
<div>
<Apptab />
<v-container>
    <h1>Dina Kommentarer</h1>
  <v-data-table
    :headers="headers"
    :items="comments"
    :items-per-page="10"
    class="elevation-1"
  >
    <template v-slot:item.schedule_name="{ item }">
      <router-link :to="'/schedule/'+item.schedule_link">{{ item.schedule_name }}</router-link>
    </template>
  </v-data-table>
  </v-container>
  </div>
</template>


<script>
import Apptab from "./apptab";
import store from "../../../store";
import axios from "axios";
  export default {
  components: {
    Apptab,
  },
    data () {
      return {
        store: store,
        headers: [
          {
            text: 'Sida',
            align: 'start',
            sortable: false,
            value: 'schedule_name',
          },
          { text: 'Kommentar', value: 'comment' },
        ],
        comments: [],
      }
    },
    created: async function() {
        var config = {
            method: "get",
            url: `${this.store.state.baseURL}comments/${this.store.state.user.id}`,
            headers: {
                "Content-Type": "application/form-data;charset=utf-8",
                "Access-Control-Allow-Origin": "*",
                Accept: "*/*"
            }
        };
        let resp = await axios(config);
        this.comments = resp.data.comments;
    },
  }
</script>